export const environment = {
    production: false,
    api_url: 'https://dsv-talonario.rs.pm.df.gov.br/api',
    sso_redirect_uri: 'https://dsv-talonario.rs.pm.df.gov.br/',
    sso_url: 'https://homolog.auth.policia.df.gov.br/realms/pmdf',
    sso_client_id: 'talonario-app',
};